const TechActionTypes = {
  TECH_LOGIN_START: "TECH_LOGIN_START",
  TECH_LOGIN_SUCCESS: "TECH_LOGIN_SUCCESS",
  TECH_LOGIN_FAILURE: "TECH_LOGIN_FAILURE",
  TECH_LOGOUT: "TECH_LOGOUT"
};
export default TechActionTypes;
